import { z } from 'zod';

/**
 * Who answered on the desk, as the traveler sees it: first name and avatar of
 * the Zendesk agent. Nothing else (no email, no id) crosses to the app. The
 * avatar is https only: web-chat renders it in an `<img>`.
 */
export const DeskAgentProfileSchema = z
  .object({
    name: z.string().trim().min(1).max(60).optional(),
    avatarUrl: z
      .url({ protocol: /^https$/ })
      .max(2048)
      .optional(),
  })
  .strict();
export type DeskAgentProfile = z.infer<typeof DeskAgentProfileSchema>;

export const DESK_SESSION_END_REASONS = [
  'ticketClosed',
  'transferToEmail',
  'ticketSolved',
  'other',
  'travelerClosed',
] as const;

/**
 * Divider the app chat draws where a human desk session starts or ends.
 * `ended.reason` says why (the agent closed or solved the ticket, moved it to
 * email, or the traveler closed it).
 */
export const DeskSessionMarkerSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('started') }).strict(),
  z.object({ kind: z.literal('ended'), reason: z.enum(DESK_SESSION_END_REASONS) }).strict(),
]);
export type DeskSessionMarker = z.infer<typeof DeskSessionMarkerSchema>;
